import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const INTEGER_REGEX = new RegExp(/^[+|-]?([0-9]+)$/);
const DECIMAL_REGEX = new RegExp(/^[+|-]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/);

export function integerValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const isValid = control.value.toString().match(INTEGER_REGEX);
    return isValid ? null : { notInteger: true };
  };
}

export function decimalValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const isValid = control.value.toString().match(DECIMAL_REGEX);
    return isValid ? null : { notDecimal: true };
  };
}

export function minExclusiveValidator(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value && control.value !== 0) return null;
    const isValid = control.value > min;
    return isValid ? null : { minExclusive: { min } };
  };
}
